export default __webpack_public_path__ + "static/media/menu.92b1fe58.svg";